import React, { useState, useEffect } from "react"
import "./styles.scss";
import { convertPrice, convertAmount } from './../../../services/convertPrice'
import calendar from './../../../images/calendar-ico.svg'
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { enUS } from 'date-fns/locale';

export default props => {
  let [ value, setValue ] = useState("");
  let [ focus, setFocus ] = useState( false );
  let [ focusCount, setFocusCount ] = useState( 0 );
  let [ error, setError ] = useState( false );
  let [ errorText, setErrorText ] = useState();
  let [ load, setLoad ] = useState( false );
  const [showCalendar, setShowCalendar] = useState(false);

  //focus count
  useEffect(() => {
    setFocusCount(++focusCount);
  }, [focus])
  // first focus 
  useEffect(() => {
    if ( focusCount === 2 && props.firstLoadValue ) {
        setValue(props.firstLoadValue)
    }
  }, [focusCount])

  //checkValue 
  let checkValue = (val) => {
    if ( props.allowChars  ) {
        if (val.length > 0) {
            let regExp = new RegExp(props.allowChars);
            if(regExp.test(val)) {
                setValue(val);
            }
        } else {
            setValue('');
        }
    } else {
        setValue(val);
    }
  }
  //change value
  useEffect(() => {
    if ( load && props.setFunction) {
        if ( props.regExp ) {
            let regExp = new RegExp(props.regExp);
            if(regExp.test(value)) {
                props.setFunction( value );
            }
        } else {
            props.setFunction( value );
        }
    }
  }, [value])

  // force validate again when clicked submit button
  useEffect(() => {
    if ( load ) {
        validate();
    }
  }, [props.forceValidate])

  useEffect(() => {
    if ( load ) {
        validate();
    }
  }, [props.forceValidateItems])

  // set value
  useEffect(() => {
      if ( props.val !== value && typeof(props.val) == 'string') {
        setValue(props.val);
        setFocus(false); 
        validate(props.val);
      }
  }, [props.val])

  // set if data is loaded
  useEffect(() => {
    if ( !load ) {
        setLoad(true);
    }
  }, [load])

  const validate = (valItem) => {
        let val = ( valItem ? valItem : value )
      // check if empty
      if ( props.required &&  val.length === 0) {
            setErrorText('Required')
            setError(true);
            return false;

        } else {
            setError(false);
        }

        //check length 
        if ( val.length < props.minChar ) {
            setError(true);       
            setErrorText('Not enough characters');
            return false;
        } else {
            setError(false);
        }

        //check format
        if ( props.regExp && val.length > 0 ) {
            
            let regExp = new RegExp(props.regExp);

            if(regExp.test(val)) {
                setError(false);
            } else {
                setError(true);       
                setErrorText('Wrong format YYYY-MM-DD')
                return false;
            }
        }
        //check min date
        if(value && value.length > 0) {
            let thisValueDate = new Date();
            let valueSplit = value.split('-');
            let year = valueSplit[0];
            let month = valueSplit[1];
            month = parseInt(month) -1;
            let day = valueSplit[2];
            thisValueDate.setFullYear(year, month, day);
            thisValueDate.setHours(0,0,0,0)
            if(props.minDate) {
                let minDate = (props.minDate);
                minDate.setHours(0,0,0,0)
                if(thisValueDate < minDate) {
                    setError(true);       
                    setErrorText('Invalid date')
                    return false;
                }else{
                    // props.setOtherInput(value);
                    setError(false);
                }
            }
    
            //check max date
            if(props.maxDate) {
                let maxDate = (props.maxDate);
                maxDate.setHours(0,0,0,0)
                if(thisValueDate > maxDate) {
                    setError(true);       
                    setErrorText('Invalid date')
                    return false;
                }else{
                    // props.setOtherInput(value);
                    setError(false);
                }
            }
        }

        return true;
        
  }

  const handleChange = value => {
    // RRRR-MM-DD
    let day = value.getDate();
    let month = value.getMonth() + 1;
    let year = value.getFullYear();
    if(month < 10) {
        month = "0" + month;
    } 
    if(day < 10) {
        day = "0" + day;
    } 
    setValue(`${year}-${month}-${day}`);
    setShowCalendar(false);
  };

  return (
    <div autoComplete="off" className={ "form-item " + props.size + ' ' + (props.label ? 'normal-label ' : '') +  ( error ? 'error-item' : '' )} >
        <label className={ ( focus || props.activeInput ? 'focus':'' ) + ' ' +
                            ( value && value.length > 0 ? 'filled' : '' ) + ' ' +  
                            ( error ? 'error' : '' ) + ' ' + 
                            ( props.activeInput ? 'disabled':'') }>
            {props.label && 
                <p className="label">{props.label}</p>
            }
            <input
            // name={props.name}
            data-name={props.name}
            onChange={ e => {
                checkValue(e.target.value);
            }}
            onFocus={  () => setFocus( true ) }
            onClick={ () => setFocus( true ) }
            autoComplete="off"
            onBlur={ (e) => { 
                
                setFocus(false); 
                validate();

                if ( props.setValidateSelectField ) {
                    props.setForceValidateFromName()
                }
                if ( props.formatPrice && e.target.value.length >= 1 ) {
                    let val =  e.target.value
                        val = val.replace(/\s/g, '');
                    let valWithoutSpaces = val;
                        val = val.replace(',', '.')
                        val = parseFloat(val);

                    let input = parseFloat(val).toFixed(2);
                    let regExp = new RegExp(props.regExp);
                    if(regExp.test(valWithoutSpaces)) {
                        setValue(convertPrice(input));
                        validate(valWithoutSpaces);
                    }
                }
                if ( props.formatAmount && e.target.value.length >= 1 ) {
                    let val =  e.target.value
                        val = val.replace(/\s/g, '');
                    let valWithoutSpaces = val;
                        val = val.replace(',', '.')
                        val = parseFloat(val);

                    let input = parseFloat(val).toFixed(2);
                    let regExp = new RegExp(props.regExp);
                    if(regExp.test(valWithoutSpaces)) {
                        setValue(convertAmount(input));
                        validate(valWithoutSpaces);
                    }
                }

            }}
            required={ props.required }
            type={ props.type }
            className={ props.class && props.class }
            placeholder={props.placeholder}
            value={ value }
            id={props.id ? props.id : ''}
            disabled={ props.disabled ? true : null }
            />
            {props.placehold &&
                <div className="placeholder">
                    <span className="underline"></span>
                    <span className="text">{ props.placehold }</span>
                </div>
            }
            { error && 
                <div className="error-message">
                    { errorText }
                </div>
            }
            {/* { props.calendar &&
                <img className="calendar" src={ calendar } alt="Kalendarz" onClick={ () => props.openCalendar() } />
            } */}
            { props.calendar &&
                <>
                    <img className="calendar" src={ calendar } alt="Kalendarz" onClick={ () => setShowCalendar(true) } />
                    {showCalendar &&
                        <div className="calendar-wrapper">
                            <Calendar
                                value={value}
                                onChange={handleChange}
                                locale="en-US"
                            /> 
                        </div>
                    }
                </>
            }
        </label>
    </div>
  )
}